import { FileListBreadcrumbs } from "./components/breadcrumbs";
import { FileListTableHeaders } from "./components/tableHeaders";
import { FileListTableView } from "./components/tableView";

export const FileList: React.FC = () => {
  return (
    <div className="flex min-w-0 flex-col">
      <FileListBreadcrumbs />

      <FileListTableHeaders />

      <FileListTableView />
    </div>
  );
};
